// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export var Addon;
(function (Addon) {
    Addon["AdditionalTitles"] = "additionalTitles";
    Addon["Author"] = "author";
    Addon["Cover"] = "cover";
    Addon["CustomSets"] = "customList";
    Addon["Delayed"] = "delayed";
    Addon["Labels"] = "labels";
    Addon["Layout"] = "layout";
    Addon["Lead"] = "lead";
    Addon["LiveFeed"] = "liveFeed";
    Addon["Meta"] = "meta";
    Addon["Premium"] = "premium";
    Addon["RelatedArticles"] = "relatedArticles";
    Addon["SmartRelated"] = "smartRelated";
    Addon["Tags"] = "tags";
})(Addon || (Addon = {}));
